export class PostingPolicy {
    'read:*' (user) {
        return user.aclPermissions.some(aclPermission => {
            return ['Posting:read:all', 'Posting:read:own', 'Posting:read:same-company', 'Posting:read:subordinate-company'].includes(aclPermission)
        })
    }
}
